export const TEST_ID = 'alert-preview-banner';
export const ALERT_TEXT = 'We are previewing the results of this alert.';
export const BACK_BUTTTON_TEXT = 'Edit Alert';
export const UPDATE_BUTTON_TEXT = 'Save Alert';
